// extracted by mini-css-extract-plugin
export default {"container":"sidebar_container__8J2nP"};